import { IKogIcon } from "@/main/@types/interfaceIcons";

export function DeliveredIcon({ height = "50px", width = "50px", color = "currentColor" }: IKogIcon) {
	return (
		<svg
			version="1.0"
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 336.000000 427.000000"
			preserveAspectRatio="xMidYMid meet"
		>
			<g transform="translate(0.000000,427.000000) scale(0.100000,-0.100000)" fill={color} stroke="none">
				<path
					d="M663 4250 c-46 -15 -78 -35 -121 -74 -70 -66 -108 -132 -128 -226
          -12 -61 -12 -79 0 -140 19 -92 58 -160 123 -220 76 -69 144 -94 263 -94 86 0
          101 3 162 31 247 116 301 435 107 634 -71 73 -141 102 -254 106 -69 2 -104 -2
          -152 -17z m255 -136 c156 -78 191 -294 67 -417 -99 -100 -272 -104 -370 -9
          -83 81 -104 207 -51 315 45 94 119 136 237 137 51 0 77 -6 117 -26z"
				/>
				<path
					d="M1923 3480 c-54 -11 -94 -32 -132 -71 -66 -66 -66 -63 -69 -401 l-3
          -308 65 0 65 0 3 294 3 294 24 26 c42 45 85 48 656 44 590 -3 562 0 605 -71
          19 -31 20 -55 20 -585 0 -627 2 -608 -74 -643 -38 -17 -74 -19 -458 -19 -230
          0 -418 1 -418 3 0 1 7 24 15 51 19 62 19 99 -1 165 -19 64 -69 122 -132 153
          -45 22 -58 23 -342 27 l-295 3 -180 277 c-204 312 -258 375 -376 434 -172 86
          -345 90 -502 11 -109 -55 -176 -132 -225 -260 l-26 -69 -4 -425 c-3 -354 -1
          -437 12 -498 29 -140 54 -171 441 -562 l352 -355 57 -352 c32 -194 64 -373 72
          -398 18 -53 74 -113 129 -140 57 -27 155 -32 212 -10 97 37 163 138 163 249 0
          28 -31 229 -70 445 -55 314 -75 406 -96 450 -21 44 -78 107 -256 287 l-228
          231 2 264 3 264 61 -95 c116 -181 199 -246 344 -270 44 -7 337 -10 910 -8
          l845 3 48 25 c65 33 113 88 131 151 24 80 24 1140 0 1220 -20 66 -89 140 -149
          160 -31 10 -169 14 -600 15 -308 1 -579 -2 -602 -6z m-1108 -434 c43 -21 95
          -58 123 -85 26 -26 133 -176 239 -333 106 -157 203 -292 216 -301 20 -13 72
          -16 324 -19 331 -3 332 -4 373 -71 40 -64 14 -147 -54 -178 -37 -17 -71 -19
          -348 -19 -184 0 -327 4 -358 11 -77 16 -133 68 -230 212 -46 69 -96 132 -111
          141 -39 23 -101 20 -133 -5 -54 -43 -56 -53 -56 -374 0 -199 4 -303 11 -318 6
          -12 118 -130 249 -262 189 -192 240 -249 254 -285 20 -55 136 -756 136 -822 0
          -52 -29 -97 -81 -123 -54 -28 -132 4 -165 67 -8 15 -39 179 -69 365 -30 186
          -60 356 -66 378 -9 33 -70 99 -369 400 -329 330 -362 366 -392 430 l-33 70 0
          445 c0 482 1 490 55 572 37 56 85 94 159 125 49 21 68 23 153 20 89 -4 105 -7
          173 -41z"
				/>
				<path
					d="M140 864 c0 -638 0 -634 74 -708 59 -59 117 -80 208 -74 56 4 83 11
          113 30 55 35 102 90 114 135 7 23 11 163 11 348 l0 311 -65 64 -65 64 0 -370
          c0 -369 0 -371 -23 -405 -38 -57 -137 -69 -189 -22 -47 41 -48 52 -48 570 l0
          489 -65 64 -65 64 0 -560z"
				/>
			</g>
		</svg>
	);
}
